import apiWorker from '../apiWorker'

const phone_numbers = {
    create: (data)              => apiWorker('post',   `/api/v1/call_center/phone_numbers`, data, true),
    delete: (phone_number_id)   => apiWorker('delete', `/api/v1/call_center/phone_numbers/${phone_number_id}`),
    find: (data)                => apiWorker('get',    `/api/v1/call_center/phone_numbers`, data),
}

export default phone_numbers;